// Delade CV-stilval: accentfärger (frikopplade från mall) och layout.
export const ACCENT_PRESETS = [
  { name: "Skogsgrön", hex: "#2E5C4B" },
  { name: "Djupblå", hex: "#1E5F8C" },
  { name: "Grafit", hex: "#1A1A1A" },
  { name: "Vinröd", hex: "#8C2F39" },
  { name: "Plommon", hex: "#5B4B8A" },
  { name: "Terrakotta", hex: "#A8502A" },
  { name: "Petrol", hex: "#0F6E6E" },
  { name: "Skiffer", hex: "#334155" },
];

export const TEMPLATE_DEFAULT_ACCENT = {
  klassisk: "#1A1A1A",
  modern: "#2E5C4B",
  kompakt: "#2E5C4B",
  grafisk: "#1E5F8C",
  sidebar: "#2E5C4B",
};

export const resolveAccent = (cv) =>
  typeof cv?.accent_color === "string" && /^#[0-9A-Fa-f]{6}$/.test(cv.accent_color)
    ? cv.accent_color
    : TEMPLATE_DEFAULT_ACCENT[cv?.template] || "#2E5C4B";
